
import { Component, Vue } from 'vue-property-decorator';
import CPSkeletonLoader from '@/components/globals/CPSkeletonLoader.vue';

@Component({
  components: {
    CPSkeletonLoader,
  },
})
export default class CPClientWatchlist extends Vue {

  public loading: boolean = false;

  get activeWatchlistItem() {
    return this.$store.state.watchlist.activeWatchlistItem;
  }

  get clientList() {
    return this.$store.state.account.details.consultantClientListForWatchlist?.ClientsInformation;
  }
  get sortedClientList() {
    const sortedClientList = this.clientList?.sort((a: any, b: any) => {
      return (
        parseInt(b.SecurityAndCashPosition.substring(1), 10) -
        parseInt(a.SecurityAndCashPosition.substring(1), 10)
      );
    });
    sortedClientList?.forEach((client: any) => {
      client.AccountInformation?.forEach((account: any) => {
        this.$nextTick(() => {
          this.$set(account, 'selected', false);
        });
      });
    });
    return sortedClientList;
  }
  get selected() {
    const selectedArr: any[] = [];
    this.sortedClientList?.forEach((client: any) => {
      client.AccountInformation?.forEach((account: any) => {
        if (account.selected) selectedArr.push(client.Id);
      });
    });
    return selectedArr;
  }

  public async addWatchlists() {
    this.loading = true;
    const req = {
      CurrentUserBostonId: this.$store.state.account.details.bostonId,
      ClientBostonIds: this.selected,
      FundId: this.activeWatchlistItem.FundId,
      NAV: this.activeWatchlistItem.NAV,
    };
    await this.$store.dispatch('addClientWatchlist', req);
    this.loading = false;
  }

  public addToWatchlist() {
    this.$store.dispatch('addToWatchlist', this.activeWatchlistItem);
  }

  public mounted() {
    this.$store.dispatch('getConsultantClientListForWatchlist', { currency: 'EUR', ISIN: this.activeWatchlistItem.ISIN });
  }
}
